import React from 'react';
import PropTypes from 'prop-types'
import * as FPT from '../utility/fpt'
import { Name } from 'guest-payment';

const NameComponent = React.createClass({

	propTypes: {
		changeNameInfo: PropTypes.func.isRequired,
		initialData: PropTypes.object,
		errorMessages: PropTypes.object,
		user: PropTypes.object,
		isRequired: PropTypes.bool,
		guestLabels: PropTypes.object,
		onRef: PropTypes.func,
	},

	getInitialState () {
		const { user: { firstName = '', lastName = '' } = {} } = this.props;
		return { firstName: firstName, lastName: lastName };
	},

	componentDidMount() {
		this.props.onRef(this)
	},

	componentWillUnmount() {
		this.props.onRef(undefined)
	},

	/*
	* Handle focus on input
	*/
	handleFocus(key) {
		let ele = {}
		ele[key] = ''
		this.setState(ele)
	},

	/*
	* Handle firstname blur
	*/
	handleBlurFirstName(firstName) {
		if (!firstName) {
			const { REQUIRED_FIRST_NAME = '' } = this.props.errorMessages;
			this.setState({ firstNameErrorMessage: REQUIRED_FIRST_NAME })
			FPT.trackError({ message: REQUIRED_FIRST_NAME, fieldId: 'firstName', code: 'REQUIRED_FIRST_NAME' });
		}
	},

	/*
	* Handle lastname blur
	*/
	handleBlurLastName(lastName) {
		if (!lastName) {
			const { REQUIRED_LAST_NAME = '' } = this.props.errorMessages;
			this.setState({ lastNameErrorMessage: REQUIRED_LAST_NAME })
			FPT.trackError({ message: REQUIRED_LAST_NAME, fieldId: 'lastName', code: 'REQUIRED_LAST_NAME' });
		}
	},

	/*
	* Handle change first name
	*/
	handleChangeFirstName(firstName) {
		this.setState({ firstName: firstName })
		this.props.changeNameInfo(firstName, this.state.lastName)
	},

	/*
	* Handle change last name
	*/
	handleChangeLastName(lastName) {
		this.setState({ lastName: lastName })
		this.props.changeNameInfo(this.state.firstName, lastName)
	},

	/*
	* Handling required payment form fields
	*/
	handleRequiredFields(params) {
		let isValid = true;
		const { errorMessages } = this.props;
		let firstNameErrorMessage, lastNameErrorMessage;
		let keysToValidate = Object.keys(params);

		keysToValidate.forEach((key) => {
			let value = params[key];
			switch (key) {
				case 'firstName':
					if (!value) {
						isValid = false
						firstNameErrorMessage = errorMessages.REQUIRED_FIRST_NAME;
						FPT.trackError({ message: firstNameErrorMessage, fieldId: 'firstname', code: 'REQUIRED_FIRST_NAME' });
					}
					break;
				case 'lastName':
					if (!value) {
						isValid = false;
						lastNameErrorMessage = errorMessages.REQUIRED_LAST_NAME;
						FPT.trackError({ message: lastNameErrorMessage, fieldId: 'lastname', code: 'REQUIRED_LAST_NAME' });
					}
					break;
				default:
					break;
			}
		})
		this.setState({ firstNameErrorMessage: firstNameErrorMessage, lastNameErrorMessage: lastNameErrorMessage })
		return isValid
	},

	/*
	* Handle first name error with any code
	*/
	handleFirstNameError(key) {
		const { errorMessages } = this.props;
		this.setState({ firstNameErrorMessage: errorMessages[key] });
		FPT.trackError({ message: errorMessages[key], fieldId: 'firstName', code: key });
	},

	/*
	* Handle last name error with any code
	*/
	handleLastNameError(key) {
		const { errorMessages } = this.props;
		this.setState({ lastNameErrorMessage: errorMessages[key] });
		FPT.trackError({ message: errorMessages[key], fieldId: 'lastName', code: key });
	},

	render() {
		return (
				<div className="name_component">
					<Name
						firstNameLabel={this.props.guestLabels.firstname}
						lastNameLabel={this.props.guestLabels.lastname}
						required={this.props.isRequired}
						firstNameDefaultValue={this.state.firstName}
						lastNameDefaultValue={this.state.lastName}
						firstNameErrorMessage={this.state.firstNameErrorMessage}
						lastNameErrorMessage={this.state.lastNameErrorMessage}
						handleChangeFirstName={this.handleChangeFirstName}
						handleChangeLastName={this.handleChangeLastName}
						handleBlurFirstName={this.handleBlurFirstName}
						handleBlurLastName={this.handleBlurLastName}
						handleFocusFirstName={() => this.handleFocus('firstNameErrorMessage')}
						handleFocusLastName={() => this.handleFocus('lastNameErrorMessage')}/>
				</div>
			)
	}
})

export default NameComponent;



// WEBPACK FOOTER //
// ./containers/name-component.js